import { IconProps } from "."

export const ClockIcon4 = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C6.52232 1 2.77426 3.94289 1.5 8H4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11 7V11L13 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1 11C1 11.3373 1.0152 11.6709 1.04494 12M8 21C7.6584 20.8876 7.32471 20.7564 7 20.6078M2.20939 16C2.01655 15.6284 1.84453 15.2433 1.69497 14.8462M3.83122 18.3065C4.1369 18.6358 4.46306 18.9441 4.80755 19.2292"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
